const PACKAGE_VERSION = "1.10.1";
const TARGETED_RPC_VERSION = "1.16.0-alpha";
export {
  PACKAGE_VERSION,
  TARGETED_RPC_VERSION
};
//# sourceMappingURL=version.js.map
